import { Box, Button, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { alpha } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

type ResultsReadyBannerProps = {
  completed: number
  onViewResults: () => void
}

/** Navy → plum CTA banner shown once the completed sample is large enough. */
export default function ResultsReadyBanner({ completed, onViewResults }: ResultsReadyBannerProps) {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('monitoring')

  return (
    <Box
      sx={{
        background: theme.affexy.gradients.ctaCard,
        color: c.white,
        borderRadius: '18px',
        p: '22px',
        display: 'flex',
        alignItems: 'center',
        gap: 2.5,
        position: 'relative',
        overflow: 'hidden',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
      }}
    >
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: '14px',
          bgcolor: alpha(c.coral, 0.22),
          display: 'grid',
          placeItems: 'center',
          flex: '0 0 50px',
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 22, color: c.coral }} />
      </Box>
      <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontFamily: theme.affexy.fonts.heading, fontWeight: 700, fontSize: 17 }}>
          {t('banner.title')}
        </Typography>
        <Typography sx={{ fontSize: 13.5, color: alpha(c.white, 0.72) }}>
          {t('banner.subtitle', { count: completed })}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        onClick={onViewResults}
        endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
        sx={{ flexShrink: 0, borderRadius: 34, px: 2.5, py: 1, fontSize: 14, fontWeight: 700 }}
      >
        {t('banner.cta')}
      </Button>
    </Box>
  )
}
